import { render, staticRenderFns } from "./SupplierNotification.vue?vue&type=template&id=e09fc820&scoped=true&"
import script from "./SupplierNotification.vue?vue&type=script&lang=js&"
export * from "./SupplierNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09fc820",
  null
  
)

export default component.exports